import { createSelector, MemoizedSelector } from '@ngrx/store';
import { createEmptyStateResource, StateResource } from '@schir-int-client/ngrx-helpers';
import { selectFeature } from 'libs/aufgabe-shared/src/lib/aufgabe.selectors';
import { AufgabeRootState } from '@schir-int-client/aufgabe-shared';
import { isNil } from 'lodash-es';
import { KorrespondenzVorlageResource } from './korrespondenz-vorlage.model';

export function korrespondenzVorlageSelector(
	korrespondenzVorlageUri: string
): MemoizedSelector<object, StateResource<KorrespondenzVorlageResource>> {
	return createSelector(selectFeature, (state: AufgabeRootState) => {
		const resource = state.aufgabeRoot.korrespondenzVorlageByUri[korrespondenzVorlageUri];
		return isNil(resource) ? createEmptyStateResource() : resource;
	});
}
